/**
 * Get display name (first name only) for privacy
 * @param {string} fullName - The full name of the user
 * @returns {string} - First name only
 */
export const getDisplayName = (fullName) => {
  if (!fullName) return '';
  return fullName.split(' ')[0];
};

/**
 * Get initial for avatar
 * @param {string} fullName - The full name of the user
 * @returns {string} - First letter uppercase
 */
export const getInitial = (fullName) => {
  if (!fullName) return 'U';
  return fullName.charAt(0).toUpperCase();
};
